export default __webpack_public_path__ + "static/hardware-bf4bdb22fb97b29bd5e0980fd95d0264.webp";